import { Fragment } from "react";
import Carousel from "react-elastic-carousel";
import Image from "next/image";
import style from "./testimonial_carousel.module.css";

export default function TestimonialCarousel() {
  const noArrow = ({ type, onClick, isEdge }) => {
    return <Fragment></Fragment>;
  };
  const noPaginate = ({ pages, activePage, onClick }) => {
    return <Fragment></Fragment>;
  };
  const breakPoint = [
    { width: 1, itemsToShow: 1.2 },
    { width: 600, itemsToShow: 2 },
    { width: 900, itemsToShow: 3 },
  ];
  const testimonialUser = [
    {
      id: 1,
      imageUrl: "/assets/icon-png/testimonial/testimonial1.webp",
      name: "Thong Wongthatchai",
      feedback:
        "ซื้อประกันเพื่อที่อยู่อาศัย ทิพยประกันภัย ที่ TQM home ซื้อออนไลน์ง่าย  เบี้ยถูกดีครับ",
    },
    {
      id: 2,
      imageUrl: "/assets/icon-png/testimonial/testimonial2.webp",
      name: "Phiraya YY",
      feedback:
        "เป็นลูกค้าทีคิวเอ็มฯปีแรกค่ะ แนะนำดีมาก ตรงกับความต้องการ และราคาสมเหตุสมผล",
    },
    {
      id: 3,
      imageUrl: "/assets/icon-png/testimonial/testimonial3.webp",
      name: "Supattira M",
      feedback: "ประกันบ้านกับ TQM แล้ว อุ่นใจมากค่ะ ปีนี้ต่อเป็นปีที่ 2 แล้ว",
    },
  ];
  return (
    <Fragment>
      <Carousel
        itemPadding={[0, 12]}
        renderArrow={noArrow}
        pagination={false}
        breakPoints={breakPoint}
        className={style.testimonial_carousel}
      >
        {testimonialUser.map((user) => (
          <div key={user.id} className={style.card}>
            <div className={style.image_wrapper}>
              <Image src={user.imageUrl} alt={`feedback of ${user.name}`} width={56} height={56} />
            </div>
            <div className={style.detail}>
              <p>{user.feedback}</p>
            </div>
            <div className={style.user_name}>
              <h5>{user.name}</h5>
            </div>
          </div>
        ))}
      </Carousel>
    </Fragment>
  );
}
